export const ERR_DEALER_NAME = {
    isError: true,
    errorMessage: "Name required",
    getErrorMessage: ({value}) => value.length ? "Invalid Name" : "Name required"
};

export const ERR_DEALER_MOBILE = {
    isError: true,
    errorMessage: "Mobile required",
    getErrorMessage: ({value}) => value.length ? "Invalid Mobile" : "Mobile required"
};

export const ERR_DEALER_EMAIL = {
    isError: true,
    errorMessage: "Email required",
    getErrorMessage: ({value}) => value.length ? "Invalid Email" : "Email required"
};

const ERR_DEALER_PINCODE = {
    isError: true,
    errorMessage: "Pincode required",
    getErrorMessage: ({ value, extras }) => {
        let text = "Pincode Required";
        if (!value && extras.pincodeText) {
            text = "Invalid Pincode";
        }
        return text;
    }
};

export const ERR_DEALERSHIP_NAME = {
    isError: true,
    errorMessage: "Dealership Name required"
};

export const ERR_TYPES = {
    NAME: "name",
    MOBILE: "mobile",
    EMAIL: "email",
    PINCODE: "pincode",
    DEALERSHIP_NAME: "dealershipName"
};

export const getErrorWithType = ({ type, customMessageOptions, extras = {} }) => {
    const errMap = {
        [ERR_TYPES.NAME]: ERR_DEALER_NAME,
        [ERR_TYPES.MOBILE]: ERR_DEALER_MOBILE,
        [ERR_TYPES.EMAIL]: ERR_DEALER_EMAIL,
        [ERR_TYPES.PINCODE]: ERR_DEALER_PINCODE,
        [ERR_TYPES.DEALERSHIP_NAME]: ERR_DEALERSHIP_NAME
    };
    return {
        [type]: {
            ...errMap[type],
            ...(customMessageOptions && {
                errorMessage: errMap[type].getErrorMessage(customMessageOptions)
            }),
            ...extras
        }
    };
};

export const unsetErrorType = ({ error, type }) => {
    const err = { ...error };
    delete err[type];
    return err;
};
